<template>
    <v-card v-if="$store.state.showDeliveryDetail" :style="{top: $store.state.detailTop}" class="order-item-detail scrollbar">
        <v-snackbar top v-model="snackbar" :color="snackbarColor" timeout="2000">{{snackbarInfo}}</v-snackbar>
        <v-icon style="position: absolute;right:10px;" @click="$store.state.showDeliveryDetail=false">mdi-close</v-icon>
        <div>
            <v-tabs color="#575757" active-class="select-tab" v-model="page">
                <v-tab>数据详情</v-tab>
                <v-tab>订单详情</v-tab>
            </v-tabs>
            <div class="line-style"></div>
        </div>
<!--        数据详情-->
        <v-tabs-items v-model="page" class="delivery-item-detail-tab scrollbar">
            <v-tab-item>
                <div v-if="$store.state.deliveryDetail.packageOperation==false">
                    <div class="order-item-content1">
                        <div class="order-item-content-child1">
                            <div style="width: 50%;display: flex;font-size: 12px;">
                                <div class="product-label-title">文件名称：<span style="color: #101010;">{{$store.state.deliveryDetail.name}}</span> </div>
                            </div>
                        </div>
                        <div class="order-item-content-child1">
                            <div style="width: 50%;display: flex;font-size: 12px;">
                                <div class="product-label-title">文件大小：<span style="color: #101010;">{{$store.state.deliveryDetail.productSize}}</span> </div>
                            </div>
                        </div>
                        <div class="order-item-content-child1">
                            <div style="display: flex;font-size: 12px;">
                                <div class="product-label-title">交付时间：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryTime}}</span> </div>
                            </div>
                        </div>
                    </div>
                    <div class="order-item-content1">
                        我们为您提供了大客户专属的对象存储服务（Object Storage Service，OBS），保障数据的海量、安全、高可靠存储。操作步骤如下：
                    </div>
                    <div class="order-item-content1">1、下载并安装OBS Browser+工具；</div>
                    <div style="display: flex;margin-left: 26px;height: 18px;">
                        <a
                                class="handbook-download-item"
                                href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win32/OBSBrowserPlus-HEC-win32.zip"
                        >windows32位下载</a>|
                        <a
                                class="handbook-download-item"
                                href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win64/OBSBrowserPlus-HEC-win64.zip"
                        >windows64位下载</a>|
                        <a
                                class="handbook-download-item"
                                href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/mac/OBSBrowserPlus-HEC-mac64.zip"
                        >mac版本下载</a>
                    </div>
                    <div class="order-item-content1">
                        <span>2、在OBS Browser+登录页选择授权码登录，复制以下授权码；</span>
                        <div
                                style="float: right;color: #4C9DF2;cursor: pointer;margin-left:220px; "
                                v-clipboard:copy="$store.state.user.authorizationCode" v-clipboard:success="copySuccess" v-clipboard:error="copyError"
                        >点击复制授权码</div>
                    </div>
                    <div class="handbook-auth-code scrollbar"><div class="handbook-auth-code-ellipsis">{{ $store.state.user.authorizationCode }}</div></div>
                    <div class="order-item-content1">3、您的专属提取码为<span style="color: #8C8C8C;">{{ $store.state.user.obsKey }}</span>；</div>
                    <div class="order-item-content1">
                        4、点击登录后，进入您的专属存储目录，可根据本订单ID<span style="color: #8C8C8C;"> <{{$store.state.deliveryDetail.demandId }}> </span>搜索对应的交付文件夹；
                    </div>
                    <div class="order-item-content1" style="margin-bottom: 0px;">5、选择所需数据进行下载。</div>
                </div>
                <div v-else>
                <div v-if="$store.state.deliveryDetail.dataType===2&&$store.state.deliveryDetail.productId" style="width: 100%;">
                    <div class="product-label-line">
                        <div style="width: 50%;display: flex;">
                            <div class="product-label-title">图层名称：</div><div class="product-label-data">{{$store.state.deliveryDetail.productName}}</div>
                        </div>
                    </div>
                    <TileDetail></TileDetail>
                </div>
                <div v-else-if="$store.state.deliveryDetail.dataType===1">
                    <div class="order-item-content">
                        <div style="width: 100%;margin: 5px 0px;">
                            <span style="color: #818181;">文件名称</span><span style="color: #101010;">：{{$store.state.deliveryDetail.name}}</span>
                        </div>
                        <div class="order-item-content-child">
                            <span style="color: #818181;">文件大小</span><span style="color: #101010;">：{{$store.state.deliveryDetail.productSize}}</span>
                        </div>
                        <div class="order-item-content-child">
                            <span style="color: #818181;">交付时间</span><span style="color: #101010;">：{{$store.state.deliveryDetail.deliveryTime}}</span>
                        </div>
                    </div>
                    <div v-if="$store.state.deliveryDetail.showProductPanel">
                        <v-toolbar light flat width="700" height="40" style="background-color: #F5F5F5;font-size: 12px;color: #848484;">
                            <div style="width: 33.3%;">产品数量: {{ productDetails.length }}景</div>
                            <div style="width: 34.8%">产品类型：{{ productTypeOptions[$store.state.deliveryDetail.productType] }}</div>
                            <div style="width: 31.8%">处理级别：{{ $store.state.deliveryDetail.productLevel }}</div>
                        </v-toolbar>
                        <v-card flat style="margin-bottom: 20px;">
                            <v-list width="700" style="padding: 0px;">
                                <v-list-item v-for="item in productDetails" :key="item.productId" style="padding: 0px;">
                                    <div class="product-item">
                                        <div style="display: flex;flex-direction: column;margin-top: 15px;margin-left: 15px;">
                                            <img :src="item.jpg" width="125" height="100" @click="showOriginPic(item.productId)">
                                            <v-btn text color="#1E88E5" style="font-size: 12px" @click="mapShow(item.imageGeo)">范围浏览</v-btn>
                                        </div>
                                        <div style="width: 100%;margin: 8px 15px 0px 60px;">
                                            <div style="margin: 10px 0px;">ID: {{item.productId}}</div>
                                            <div style="display: flex;justify-content: space-between;color: #4A4A4A;">
                                                <div class="product-item-div">
                                                    <div>分辨率: {{item.imageGsd}}米</div>
                                                    <div>云量: {{item.cloudPercent}}%</div>
                                                    <div>传感器: {{item.sensor}}</div>
                                                </div>
                                                <div class="product-item-div">
                                                    <div>拍摄卫星: {{satelliteNewList[item.satelliteId]}}</div>
                                                    <div>侧摆: {{item.rollSatelliteAngle}}°</div>
                                                    <div>太阳高度角: {{item.solarElevation.toFixed(2)}}°</div>
                                                </div>
                                                <div class="product-item-div">
                                                    <div>采集时间: {{item.imagingTime}}</div>
                                                    <div>总面积: {{parseInt(item.productArea).toFixed(2)}}k㎡</div>
                                                    <div>谱段数: {{bandsDetail(item)}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </div>
                </div>
                </div>
            </v-tab-item>
            <v-tab-item>
                <div v-if="!$store.state.hasOrderDetail" class="loading-demand-detail">
                    <v-card color="primary" dark width="410">
                        <v-card-text style="display: flex;flex-direction: column;">
                            <div style="margin-bottom: 5px;text-align: center">正在获取订单详情，请耐心等待</div>
                            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </div>
                <DemandDetail v-else></DemandDetail>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>
<script>
    import DemandDetail from "./DemandDetail";
    import TileDetail from "./TileDetail";

    export default {
        name: "DeliveryItemDetail",
        data() {
            return {
                snackbar: false, snackbarInfo: "", snackbarColor: "",
                page: 0,
                productDetails: [],
                options: { zoomControl: false, attributionControl: false },
                subdomains: { subdomains: ['0', '1', '2', '3'] },
                geo: { type: "Point", coordinates: [125.6, 10.1] },
                targetGeojsonStyle: { color: '#00BCD4', weight: 2, fillOpacity: 0 },
                productTypeOptions: {
                    "IMAGE": "普通光学", "NIGHT": "夜光", "VIDEO": "卫星视频", "MULTISPECTRAL": "多光谱",
                    "LPB": "推扫", "STERO": "立体", "OTHER": "其他数据", "OFFLINE": "线下订单"
                },
                satelliteNewList: {
                    "JL101A": "光学A星", "JL103B": "视频03星", "JL104B": "视频04星", "JL105B": "视频05星", "JL106B": "视频06星",
                    "JL107B": "视频07星", "JL108B": "视频08星", "JL1GP01": "光谱01星", "JL1GP02": "光谱02星", "JL1GF02A": "高分02A星",
                    "JL1GF02B": "高分02B星", "JL1KF01A": "宽幅01A星", "JL1GF03A": "高分03A星", "JL1GF03B01": "高分03B01星",
                    "JL1GF03B02": "高分03B02星", "JL1GF03B03": "高分03B03星", "JL1GF03B04": "高分03B04星", "JL1GF03B05": "高分03B05星",
                    "JL1GF03B06": "高分03B06星", "JL1GF03C01": "高分03C01星", "JL1GF03C02": "高分03C02星", "JL1GF03C03": "高分03C03星",
                },
            }
        },
        components: {
            TileDetail,
            DemandDetail,
        },
        created() {
            this.eventVue.$on("showDeliveryDetail", () => {
                this.productDetails = [];
                if (this.$store.state.deliveryDetail.showProductPanel) {
                    this.getProductDetail();
                }
            });
        },
        methods: {
            copySuccess() {
                this.snackbarColor="success"
                this.snackbarInfo = "已复制到剪切板"
                this.snackbar = true;
            },
            copyError() {
                this.snackbarColor="error"
                this.snackbarInfo = "复制失败"
                this.snackbar = true;
            },
            mapShow(wkt){
                this.$store.state.geo = JSON.parse(wkt)
                this.$store.state.bounds = L.geoJSON(this.$store.state.geo).getBounds();
                this.$store.state.mapShowDialog = true
            },
            bandsDetail(item) {
                let tmp =''
                if (item.productType === 2 || item.productType === 3){
                    tmp = '3 (R+G+B)'
                } else if (item.productType === 1) {
                    if (item.satelliteId === 'JL101A') {
                        tmp = '5 (PAN+R+G+B+NIR)'
                    } else {
                        tmp = '6 (PAN+R+G+B+Rededge+NIR)'
                    }
                } else if (item.productType === 4) {
                    tmp = '1 ' + item.productBand
                }
                return tmp
            },
            getProductDetail(){
                if (this.productDetails.length === 0) {
                    for (let productId of this.$store.state.deliveryDetail.productIds) {
                        this.axios({
                            url: 'http://121.36.48.158:7001/metadataQuery/getProductInfoByProductId',
                            method: "post",
                            params: {
                                "productId": productId
                            }
                        }).then((res) => {
                            this.productDetails.push(res.data.data);
                        })
                    }
                }
            },
            showOriginPic(id) {
                this.$store.state.bifProductId = id;
                this.$store.state.showOriginImage = true;
            }
        }
    }
</script>
<style scoped>
    .order-item-detail{
        position: absolute;
        left: 0px;
        width: 780px;
        height: 575px;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: auto;
        z-index: 2;
    }
    .select-tab {
        font-weight: bold;
    }
    .order-item-content {
        width: 700px;
        padding: 10px 20px 15px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 12px;
    }
    .order-item-content1 {
        width: 700px;
        padding: 10px 20px 5px 30px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 12px;
    }
    .order-item-content-child1 {
        width: 50%;
        margin: 5px 0px;
    }
    .order-item-content-child {
        width: 50%;
        margin: 5px 0px;
    }
    .product-item {
        display: flex;
        width: 100%;
        background-color: #FAFAFA;
        font-size: 12px;
    }
    .product-item-div div {
        margin: 0px 0px 10px;
    }
    .line-style {
        height: 1px;
        width: 700px;
        background-color: #DFDFDF;
        margin-bottom: 2px;
    }
    .product-label-line {
        display: flex;
        width: 100%;
        margin: 8px;
    }
    .product-label-line1 {
        display: flex;
        width: 100%;
        margin: 17px 8px 8px 8px;
    }
    .product-label-title {
        color: #818181;
        font-size: 12px;
    }
    .product-label-data {
        color: #101010;
        font-size: 12px;
    }
    .delivery-item-detail-tab {
        overflow-y: auto;
        width: 780px;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
    }
    .loading-demand-detail {
        display: flex;
        justify-content: center;
        margin-top: 180px;
    }
    .handbook-label {
        font-size: 12px;
        color: #101010;
        margin: 14px 8px 10px 30px;
    }
    .handbook-download-item {
        font-size: 12px;
        color: #8C8C8C;
        margin: 0px 12px;
        padding: 1px 0px;
        text-decoration: none;
    }
    .handbook-download-item:hover {
        color: #4C9DF2;
        text-decoration: underline;
    }
    .handbook-auth-code {
        padding: 8px 10px;
        margin: 0px 8px 0px 30px;
        width: 690px;
        height: 176px;
        line-height: 20px;
        border-radius: 3px;
        border: 1px solid #BBBBBB;
        font-size: 10px;
        color: #8C8C8C;
    }
    .handbook-auth-code-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
</style>